import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function AdminRefreshWallets() {
  const [s, setS] = useState(null);
  const load = () => api.get("/wallet/admin/refresh-all").then(({ data }) => setS(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!s?.running) return;
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [s?.running]);
  const go = async () => {
    try { await api.post("/wallet/admin/refresh-all"); toast.success("Re-checking every linked wallet"); setS((x) => ({ ...x, running: true, done: 0 })); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!s) return null;
  const pct = s.total ? Math.round((100 * (s.done || 0)) / s.total) : 0;
  return (
    <div className="glass rounded-2xl p-5 mb-6 flex flex-col md:flex-row md:items-center gap-4" data-testid="admin-refresh-wallets">
      <div className="flex-1 min-w-0">
        <p className="font-display text-lg text-amber-100">Refresh all wallets</p>
        <p className="text-xs text-slate-400" data-testid="admin-refresh-linked">
          Re-checks Exclusive, Wolfpack 777, PUPS, $MWP and 1/1 wolves for {s.linked.polygon} Polygon and {s.linked.solana} Solana linked wallets.
        </p>
        {s.running ? (
          <div className="mt-2" data-testid="admin-refresh-progress">
            <div className="h-1.5 rounded-full bg-slate-800 overflow-hidden"><div className="h-full bg-amber-400 transition-[width] duration-500" style={{ width: `${pct}%` }} /></div>
            <p className="text-[11px] text-slate-400 mt-1">{s.done || 0} of {s.total || "…"} checked</p>
          </div>
        ) : s.finished_at && (
          <p className="text-[11px] text-slate-400 mt-1" data-testid="admin-refresh-last">
            Last run {new Date(s.finished_at).toLocaleString()}: {s.done} checked{s.failed ? `, ${s.failed} couldn't be reached (try again)` : ", all up to date"}.
          </p>
        )}
      </div>
      <button data-testid="admin-refresh-wallets-btn" onClick={go} disabled={s.running}
        className="ember-btn px-5 py-2.5 rounded-full text-sm inline-flex items-center gap-2 disabled:opacity-60 shrink-0">
        <RefreshCw className={`w-4 h-4 ${s.running ? "animate-spin" : ""}`} />{s.running ? "Refreshing…" : "Refresh all wallets"}
      </button>
    </div>
  );
}
